<template>
  <div class="campaign-image">
    <b-field grouped>
      <figure v-if="hasImage" class="image-preview mr-3" :class="[previewClass, { 'transparency-bg': supportTransparency }]">
        <img :src="imageSrc" :style="imageStyle" />
      </figure>
      <div class="buttons">
        <b-button
          :type="hasImage ? 'is-light' : 'is-primary'"
          :icon-left="hasImage ? 'pencil' : 'plus'"
          @click="selectImage">
          {{ hasImage ? 'Change' : 'Add Image' }}
        </b-button>
        <b-button
          v-if="hasImage"
          type="is-danger"
          icon-left="delete"
          outlined
          @click="deleteImage">
        </b-button>
      </div>
    </b-field>
    <SelectCampaignImageModal v-if="false" /> <!-- Silence warning -->
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import SelectCampaignImageModal from "@/components/modals/SelectCampaignImageModal.vue"
import Storage from "@/firebase/storage"

export default {
  name: 'EditCampaignImage',
  components: {
    SelectCampaignImageModal
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    storagePath: {
      type: String,
      default: 'images/campaigns'
    },
    aspectRatio: {
      type: String,
      default: 'flexible'
    },
    title: {
      type: String,
      default: 'Select Image'
    },
    supportTransparency: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasImage() {
      return this.value && this.value.length > 0
    },
    imageSrc() {
      return this.value
    },
    previewClass() {
      switch (this.aspectRatio) {
        case 'square': return 'is-square'
        case '16:9': return 'is-16by9'
        case '4:3': return 'is-4by3'
        default: return ''
      }
    },
    imageStyle() {
      return {
        objectFit: 'cover',
        borderRadius: '8px',
        maxHeight: '150px',
        width: 'auto'
      }
    }
  },
  methods: {
    selectImage() {
      this.$buefy.modal.open({
        parent: this,
        component: SelectCampaignImageModal,
        hasModalCard: true,
        trapFocus: true,
        customClass: 'select-image-modal-wrapper',
        props: {
          title: this.title,
          aspectRatio: this.aspectRatio,
          supportTransparency: this.supportTransparency
        },
        events: {
          'image-selected': data => {
            this.saveImage(data.blob, data.extension || 'jpg')
          }
        }
      })
    },
    saveImage(blob, extension) {
      const imageId = uuidv4()
      const path = `${this.storagePath}/${imageId}.${extension}`

      const uploadTask = Storage.ref().child(path).put(blob)

      this.$buefy.toast.open({ type: 'is-info', message: 'Uploading image...' })

      uploadTask.on('state_changed',
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          console.log('Upload is ' + progress + '% done')
        },
        (error) => {
          this.$buefy.toast.open({ type: 'is-danger', message: `Error uploading image: ${error}` })
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            console.log('File available at', downloadURL)
            this.$emit('input', downloadURL)
          })
        }
      )
    },
    deleteImage() {
      this.$buefy.dialog.confirm({
        title: 'Remove Image',
        message: 'Are you sure you want to remove this image?',
        confirmText: 'Remove',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$emit('input', '')
        }
      })
    }
  }
}
</script>

<style scoped>
.image-preview {
  max-width: 200px;
  overflow: hidden;
  border-radius: 8px;
  background: #f5f5f5;
}
.image-preview img {
  display: block;
}
.buttons {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}

/* Checkerboard pattern for transparency preview */
.transparency-bg {
  background-image:
    linear-gradient(45deg, #ccc 25%, transparent 25%),
    linear-gradient(-45deg, #ccc 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #ccc 75%),
    linear-gradient(-45deg, transparent 75%, #ccc 75%);
  background-size: 16px 16px;
  background-position: 0 0, 0 8px, 8px -8px, -8px 0px;
  background-color: #fff;
}
</style>
